import React from "react";

import P from "components/Typography/P";
import styles from "./Paragraph.module.scss";

const Paragraph = ({ children }: { children: string }) => {
    return <P className={styles.p}>{children}</P>;
};

export default Paragraph;
